<section class="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-surface-1/70">
  @if (showAccessBanner()) {
    <div
      class="mx-6 mt-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100"
      role="alert"
    >
      @if (allAccessDenied()) {
        You don't have access to any unpaid payment products:
        <span class="font-semibold">{{ deniedProductLabels().join(', ') }}</span>
      } @else {
        You don't have access to:
        <span class="font-semibold">{{ deniedProductLabels().join(', ') }}</span>
      }
    </div>
  }

  <div class="px-6 py-5">
    <h2 class="text-[24px] font-bold leading-[1.3] text-[#141437] dark:text-white">Unpaid Payments Overview</h2>
  </div>

  <div class="grid grid-cols-1 gap-5 px-6 sm:grid-cols-2 lg:grid-cols-3">
    @for (card of visibleCards(); track card.product.key) {
      <app-unpaid-payments-hub-product-card
        [product]="card.product"
        [data]="card.data"
        [loading]="card.loading"
        [unauthorized]="card.unauthorized ?? false"
        (cardClick)="openProduct(card.product.routeSegment)"
      ></app-unpaid-payments-hub-product-card>
    }
  </div>

  <p class="px-6 pb-6 pt-3 text-[11px] font-normal leading-snug text-slate-400 dark:text-slate-500 text-end">
    * Values are cached for 10 minutes and refresh automatically.
  </p>
</section>
